/**
 * The chart pane's placeholder, shown once the charts sidebar is open but before the
 * selection can draw anything.
 *
 * Smaller than the pane on purpose: it stands in for a chart that doesn't exist yet, and
 * filling the space would read as one that failed to load.
 */

import { Box, Skeleton, Typography } from '@mui/material';

const containerSx = {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    p: 2,
};

const cardSx = {
    width: '50%',
    height: '50%',
    minWidth: 200,
    minHeight: 140,
    maxWidth: 420,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
};

const plotSx = {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'flex-end',
    gap: 1,
};

/** Uneven on purpose: even bars read as a spinner rather than a chart. */
const BAR_HEIGHTS = ['55%', '80%', '40%', '95%', '65%'];

export default function ChartSkeleton() {
    return (
        <Box sx={containerSx}>
            <Box sx={cardSx}>
                <Box aria-hidden sx={plotSx}>
                    {BAR_HEIGHTS.map((height, index) => (
                        <Skeleton
                            // Fixed list, never reordered, so the index is identity enough.
                            key={index}
                            variant='rounded'
                            width='100%'
                            sx={{ height, flex: 1 }}
                        />
                    ))}
                </Box>

                <Skeleton aria-hidden variant='rounded' height={6} width='100%' />

                <Typography variant='caption' color='text.secondary' align='center'>
                    Add more data to render a chart
                </Typography>
            </Box>
        </Box>
    );
}
